import { bl_sfa_sales_lead_event_RowClass } from "../../../dbschema/bl_sfa_sales_lead_event.model";
import { bl_sfa_sales_lead_ext_RowClass } from "../../../dbschema/bl_sfa_sales_lead_ext.model";
import { bl_sfa_sales_lead_hdr_RowClass } from "../../../dbschema/bl_sfa_sales_lead_hdr.model";
import { bl_sfa_sales_lead_contact_link_RowClass } from "../../../dbschema/bl_sfa_sales_lead_contact_link.model";
import { bl_sfa_sales_lead_entity_link_RowClass } from "../../../dbschema/bl_sfa_sales_lead_entity_link.model";

import { BaseContainerModel } from "../../base-container.model";

export class SfaSalesLeadContainerModel extends BaseContainerModel {
    bl_sfa_sales_lead_hdr: bl_sfa_sales_lead_hdr_RowClass = new bl_sfa_sales_lead_hdr_RowClass();
    bl_sfa_sales_lead_exts: bl_sfa_sales_lead_ext_RowClass[] =[];
    bl_sfa_sales_lead_events: bl_sfa_sales_lead_event_RowClass [] = [];
    // bl_sfa_sales_lead_contacts: bl_sfa_sales_lead_contact_link_RowClass [] = [];
    // bl_sfa_sales_lead_entities: bl_sfa_sales_lead_entity_link_RowClass [] = [];
}